import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isEmpty } from "@duosoftbg/nacid-components";
import SitemapLinkDialogBody from "./SitemapLinkDialogBody";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { sitemapSection } from "../../../../../../utils/constants";
import { closeEditModal } from "../../../../../../store/redux/slice/ComponentsControl/sitemapControl";

const SitemapLinkDialog = () => {
  const dispatch = useAppDispatch();

  const { open, object } = useAppSelector((state) => {
    return state.ComponentsControl.sitemapControl.sections[sitemapSection.link].modals.edit;
  });

  const handleCloseDialog = () => {
    dispatch(closeEditModal({ section: sitemapSection.link }));
  };

  const { t } = useTranslation();
  const isEditMode = !isEmpty(object.id);

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => handleCloseDialog()}
        aria-labelledby="sitemap-link-dialog-title"
      >
        <DialogTitle id="sitemap-link-dialog-title" style={{ textAlign: "center" }}>
          {!isEditMode && t("t.sitemap.link.create.dialog")}
          {isEditMode && t("t.sitemap.link.edit.dialog")}
        </DialogTitle>
        <DialogContent>
          <SitemapLinkDialogBody
            editingLink={object}
            setOpen={handleCloseDialog}
            isEditMode={isEditMode}
          ></SitemapLinkDialogBody>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SitemapLinkDialog;
